import { useState } from 'react'
import { Button, Dropdown, Form } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ApiRoutes from 'assets/js/classes/ApiRoutes'
import Dashboard from 'assets/js/classes/Dashboard'
import { AxiosMethods } from 'assets/js/utilities/axios'
import { FormControlProvider } from 'contexts/FormControlContext'
import FormButton from 'components/forms/FormButton'
import { stateUpdateDashboard, useDashboardDispatch, useDashboardState } from 'contexts/DashboardContext'
import { stateUpdateSearchBar, useSearchBarDispatch, useSearchBarState } from 'contexts/SearchBarContext'
import { stateUpdateSidebar, useSidebarDispatch, useSidebarState } from 'contexts/SidebarContext'

export default function DashboardSettings() {
  // STATE PARAMS
  const [showDropdown, setShowDropdown] = useState(false);

  // CONTEXT PARAMS - DASHBOARD
  const { buckets, pageReset, withTrashedBuckets } = useDashboardState();
  const dashboardDispatch = useDashboardDispatch();
  
  // CONTEXT - SEARCH BAR
  const { dataset } = useSearchBarState();
  const searchBarDispatch = useSearchBarDispatch();

  // CONTEXT - SIDEBAR
  const { buckets: sidebarBuckets, bucketsRef: sidebarBucketsRef } = useSidebarState();
  const sidebarDispatch = useSidebarDispatch();

  // FUNCTIONS
  const newBucketEffect = () => {
    // HIDE THE DROPDOWN
    setShowDropdown(false);

    // REMOVE SCROLL SNAP
    stateUpdateDashboard(dashboardDispatch, { scrollSnap: false });

    // SCROLL TRELLO CONTAINER
    const $trello = document.getElementById('trello');
    const scrLft = $trello?.querySelector('div').offsetWidth;
    const duration = 200;
    const steps = 100;

    Array.from(Array(steps).keys()).map(i => setTimeout(
      () => $trello.scrollLeft = scrLft - (scrLft * i / steps), i / steps * duration
    ));

    // RESTORE SCROLL SNAP
    setTimeout(() => stateUpdateDashboard(dashboardDispatch, { scrollSnap: true }), duration);
  }

  return (
    <Dropdown
      align="start"
      autoClose="outside"
      className="flex-fill align-self-stretch d-flex mb-2"
      onToggle={(show, meta) => setShowDropdown(!meta.source === 'rootClose')}
      show={showDropdown}
    >
      <Dropdown.Toggle
        className="align-self-stretch shadow-sm w-100 noCaret"
        onClick={() => setShowDropdown(state => !state)}
        variant="primary"
      >
        <FontAwesomeIcon fixedWidth icon={['far', 'gear']} />
        <FontAwesomeIcon fixedWidth icon={['fas', 'caret-down']} />
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Form 
          autoComplete="false"
          onSubmit={e => e.preventDefault()}
        >
          <FormControlProvider>
            <FormButton
              className="dropdown-item rounded-0"
              eventListeners={[
                {
                  event: `${AxiosMethods.POST}::${ApiRoutes.BUCKETS}`,
                  listener: newBucketEffect,
                }
              ]}
              loadStatus="Creating..."
              modelContext={{ 
                dashboard: {
                  dataset: buckets, 
                  dispatch: dashboardDispatch,
                  prop: 'buckets',
                  update: stateUpdateDashboard,
                },
                searchBar: {
                  dataset,
                  dispatch: searchBarDispatch,
                  prop: 'dataset',
                  update: stateUpdateSearchBar,
                },
                sidebar: {
                  dataset: sidebarBuckets,
                  dispatch: sidebarDispatch,
                  prop: 'buckets',
                  update: stateUpdateSidebar,
                },
              }}
              onClick={Dashboard.handleCreateBucket}
              variant="link"
            >
              <FontAwesomeIcon fixedWidth icon={['far', 'square-kanban']} className="mr-1" />
              New List/Dashboard
            </FormButton>
          </FormControlProvider>
          { !withTrashedBuckets &&
            <Button
              className="dropdown-item rounded-0"
              hide={withTrashedBuckets}
              onClick={() => (stateUpdateDashboard(dashboardDispatch, { withTrashedBuckets: true }), pageReset.current = Object.fromEntries(Object.keys(pageReset.current).map(key => [key, true])))}
              variant="link"
            >
              <FontAwesomeIcon fixedWidth icon={['far', 'eye']} className="mr-1" />
              Show Deleted Lists/Dashboards
            </Button>
          }
          { withTrashedBuckets &&
            <Button
              className="dropdown-item rounded-0"
              hide={!withTrashedBuckets}
              onClick={() => (stateUpdateDashboard(dashboardDispatch, { withTrashedBuckets: false }), pageReset.current = Object.fromEntries(Object.keys(pageReset.current).map(key => [key, true])))}
              variant="link"
            >
              <FontAwesomeIcon fixedWidth icon={['far', 'eye-slash']} className="mr-1" />
              Hide Deleted Lists/Dashboards
            </Button>
          }
        </Form>
      </Dropdown.Menu>
    </Dropdown>
  )
}